var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 372.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#e6e6e6;}.cls-3{fill:#f0f0f0;}.cls-4,.cls-9{fill:#fff;}.cls-5{fill:#e0e0e0;}.cls-6{fill:#f5f5f5;}.cls-7{fill:#fafafa;}.cls-10,.cls-17,.cls-8{fill:#407bff;}.cls-16,.cls-17,.cls-9{opacity:0.3;}.cls-10{opacity:0.6;}.cls-11{fill:#263238;}.cls-12{fill:#ff8b7b;}.cls-13{fill:#ff5652;}.cls-14{opacity:0.2;}.cls-15{opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 327.45,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 290.21,
    y: 334.26,
    width: 25.46,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 395.11,
    y: 339.67,
    width: 60.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.46,
    y: 334.38,
    width: 62.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169,
    y: 341.86,
    width: 13.04,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 194.71,
    y: 341.86,
    width: 59.38,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.46,
    y: 337.64,
    width: 38.45,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237,282.85H43.91a5.71,5.71,0,0,1-5.7-5.71V5.71A5.71,5.71,0,0,1,43.91,0H237a5.71,5.71,0,0,1,5.71,5.71V277.14A5.71,5.71,0,0,1,237,282.85ZM43.91.25a5.46,5.46,0,0,0-5.45,5.46V277.14a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V5.71A5.47,5.47,0,0,0,237,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.31,282.85H260.21a5.72,5.72,0,0,1-5.71-5.71V5.71A5.72,5.72,0,0,1,260.21,0h193.1A5.71,5.71,0,0,1,459,5.71V277.14A5.71,5.71,0,0,1,453.31,282.85ZM260.21.25a5.47,5.47,0,0,0-5.46,5.46V277.14a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V5.71A5.47,5.47,0,0,0,453.31.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "195.96 240.71 129.56 240.71 125.53 194.21 191.93 194.21 195.96 240.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "199.4 240.71 133 240.71 128.97 194.21 195.37 194.21 199.4 240.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "142.08 230.73 139.86 204.2 186.29 204.2 188.51 230.73 142.08 230.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 203.1,
    y: 240.71,
    width: 7.79,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 207.94,
    y: 240.71,
    width: 5.41,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.94,
    y: 240.71,
    width: 75.41,
    height: 9.57,
    transform: "translate(351.29 491) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 132.81,
    y: 250.29,
    width: 7.79,
    height: 77.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.65,
    y: 250.29,
    width: 5.41,
    height: 77.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.36,
    y: 250.29,
    width: 7.79,
    height: 77.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.2,
    y: 250.29,
    width: 5.41,
    height: 77.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 153.8,
    y: 250.29,
    width: 7.79,
    height: 77.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 158.63,
    y: 250.29,
    width: 5.41,
    height: 77.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.36,
    y: 240.71,
    width: 60.58,
    height: 9.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 129.51,
    y: 24.46,
    width: 234.33,
    height: 130.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 130.69,
    y: 24.46,
    width: 246.02,
    height: 130.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.49,
    y: -29.3,
    width: 122.42,
    height: 237.98,
    transform: "translate(343.39 -164.01) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "231.07 150.9 276 28.48 201.85 28.48 156.92 150.9 231.07 150.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "302.44 150.9 347.37 28.48 291.43 28.48 246.5 150.9 302.44 150.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 418.19,
    y: 202.85,
    width: 19.92,
    height: 124.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "432.87 327.45 438.11 327.45 438.11 317.85 427.38 317.85 432.87 327.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 234.53,
    y: 202.85,
    width: 19.92,
    height: 124.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 249.88,
    y: 202.85,
    width: 188.23,
    height: 122.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.55,242.22H253.45V207.76h181.1Zm-180.1-1h179.1V208.76H254.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.67,224.49H288.84c-5.28,0-10.37-4.27-14-11.7l-.34-.72H417l-.34.72C413,220.22,408,224.49,402.67,224.49ZM276.14,213.07c3.38,6.63,8,10.42,12.7,10.42H402.67c4.72,0,9.32-3.79,12.7-10.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "255.12 327.45 249.88 327.45 249.88 317.85 260.61 317.85 255.12 327.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.55,281.08H253.45V246.62h181.1Zm-180.1-1h179.1V247.62H254.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.67,263.35H288.84c-5.28,0-10.37-4.26-14-11.69l-.34-.72H417l-.34.72C413,259.09,408,263.35,402.67,263.35ZM276.14,251.94c3.38,6.63,8,10.41,12.7,10.41H402.67c4.72,0,9.32-3.78,12.7-10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.55,320H253.45V285.49h181.1Zm-180.1-1h179.1V286.49H254.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.67,302.22H288.84c-5.28,0-10.37-4.26-14-11.7l-.34-.71H417l-.34.71C413,298,408,302.22,402.67,302.22ZM276.14,290.81c3.38,6.63,8,10.41,12.7,10.41H402.67c4.72,0,9.32-3.78,12.7-10.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.98 219.33 120.98 221.75 119.44 221.75 118.16 240.71 99.32 240.71 98.05 221.75 96.5 221.75 96.5 219.33 120.98 219.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.78,172.26C113.24,161,98,157.73,78.64,157.32c-18.41-.39-24.31-6.91-24.31-6.91s.06,26.38,26.59,35.93C106.11,195.41,116.33,183.58,114.78,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.38,197.87c.32-4.65,7.74-13.18,25.59-9.3,12.9,2.8,17.7-3.88,17.7-3.88s-1.2,18.87-20.6,24.55C109.64,214.63,104.81,206,105.38,197.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.45,226.45a.69.69,0,0,0,.53-.24c1.29-1.53.23-5.19-1.23-10.26-1.88-6.5-4.22-14.6-2.24-20.48a83,83,0,0,1,3.84-9.07c2.8-5.92,5.22-11,3.2-16.38a.68.68,0,0,0-.89-.4.7.7,0,0,0-.4.89c1.81,4.79-.38,9.43-3.16,15.3a86.46,86.46,0,0,0-3.9,9.22c-2.11,6.29.29,14.61,2.22,21.3,1.14,3.94,2.32,8,1.51,9a.68.68,0,0,0,.08,1A.66.66,0,0,0,109.45,226.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-6",
    cx: 250,
    cy: 361.29,
    rx: 193.89,
    ry: 11.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Login"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "249.96 306.1 107.96 306.1 100.19 77.73 242.19 77.73 249.96 306.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "257.05 299.01 115.05 299.01 107.27 70.64 249.27 70.64 257.05 299.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "257.05 299.01 115.05 299.01 107.27 70.64 249.27 70.64 257.05 299.01"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 180.5,
    cy: 136.14,
    rx: 39.27,
    ry: 40.63,
    transform: "translate(-43.12 169.41) rotate(-45.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.47,136.14a32.06,32.06,0,0,1-3.45,15.7,31.61,31.61,0,0,1-28.4,17.26,34.28,34.28,0,0,1-29.56-17.26,33.52,33.52,0,0,1-4.52-15.7,31.64,31.64,0,0,1,31.84-33A34.36,34.36,0,0,1,213.47,136.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M210,151.84a31.61,31.61,0,0,1-28.4,17.26,34.28,34.28,0,0,1-29.56-17.26,50.51,50.51,0,0,1,28.68-8.78A53.4,53.4,0,0,1,210,151.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 180.12,
    cy: 124.86,
    rx: 14.44,
    ry: 14.94,
    transform: "translate(-35.19 165.76) rotate(-45.49)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "228.52 216.31 137.94 216.31 137.33 198.31 227.91 198.31 228.52 216.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "229.62 248.48 139.03 248.48 138.42 230.48 229.01 230.48 229.62 248.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.66,233l-21.83,3a1.53,1.53,0,0,0-1.32,1.81l2.87,14.63a1.75,1.75,0,0,0,1.94,1.36l21.83-3a1.52,1.52,0,0,0,1.31-1.8l-2.86-14.63A1.74,1.74,0,0,0,194.66,233Zm-6.27,14.81-4,.54-.39-4.72a2.82,2.82,0,0,1-1.63-2,2.49,2.49,0,0,1,2.16-3,2.86,2.86,0,0,1,3.16,2.23,2.42,2.42,0,0,1-.78,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M192.5,232.17h0a1.56,1.56,0,0,1-1.72-1.21l-.28-1.43a8.23,8.23,0,0,0-8.62-6.56,7,7,0,0,0-6.46,8.39l.32,1.65a1.35,1.35,0,0,1-1.17,1.6h0a1.54,1.54,0,0,1-1.72-1.21l-.27-1.4a9.84,9.84,0,0,1,8-11.74,11.19,11.19,0,0,1,12.8,8.66l.32,1.65A1.35,1.35,0,0,1,192.5,232.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "214.67 273.69 155.7 273.69 155.31 261.97 214.27 261.97 214.67 273.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M186.22,207.31A3.16,3.16,0,0,1,183,210.6a3.44,3.44,0,0,1-3.41-3.29,3.16,3.16,0,0,1,3.18-3.29A3.43,3.43,0,0,1,186.22,207.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M172,207.31a3.15,3.15,0,0,1-3.18,3.29,3.43,3.43,0,0,1-3.4-3.29,3.16,3.16,0,0,1,3.18-3.29A3.42,3.42,0,0,1,172,207.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M157.87,207.31a3.16,3.16,0,0,1-3.18,3.29,3.42,3.42,0,0,1-3.4-3.29,3.16,3.16,0,0,1,3.18-3.29A3.42,3.42,0,0,1,157.87,207.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M200.39,207.31a3.16,3.16,0,0,1-3.18,3.29,3.42,3.42,0,0,1-3.4-3.29A3.15,3.15,0,0,1,197,204,3.42,3.42,0,0,1,200.39,207.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M214.56,207.31a3.15,3.15,0,0,1-3.18,3.29,3.43,3.43,0,0,1-3.4-3.29,3.16,3.16,0,0,1,3.18-3.29A3.42,3.42,0,0,1,214.56,207.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M333.91,119.33c1.33,2.13,2.44,4.18,3.58,6.31s2.17,4.27,3.18,6.46a92.36,92.36,0,0,1,5.1,13.73c.18.59.31,1.22.46,1.83l.22.93.11.46.13.76a13.63,13.63,0,0,1-.31,5.15,29.16,29.16,0,0,1-3.12,7.46,59.22,59.22,0,0,1-8.88,11.67l-4.21-3.19a111.25,111.25,0,0,0,5.63-12,25.14,25.14,0,0,0,1.53-5.63,4.44,4.44,0,0,0-.08-1.77l-.4-1.22c-.16-.51-.31-1-.5-1.51a112.53,112.53,0,0,0-5.27-12.08c-2-4-4.15-8-6.3-11.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M331.24,169.47l-4.6,2.44,5.28,6.18s3.3-2.23,3.45-5.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "320.47 175.72 326.12 180.21 331.92 178.09 326.64 171.91 320.47 175.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M301.15,86.61c-.11.56-.5,1-.86.87s-.57-.58-.46-1.14.5-.94.87-.87S301.26,86.06,301.15,86.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M300.7,87.57a20,20,0,0,1-3.62,4.21,3.28,3.28,0,0,0,2.56,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M298.9,107.19l0-6.56,8.68,1.05s-.14,5.64-5,7.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "301.4 95.91 307.51 97.67 307.62 101.68 298.94 100.63 301.4 95.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M307.51,97.67l-6.11-1.76-1.19,2.28a9.73,9.73,0,0,0,5.64,8.48,9.56,9.56,0,0,0,1.77-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.81,83.94a.34.34,0,0,0,.25-.56,3.32,3.32,0,0,0-2.84-1.1.33.33,0,0,0-.27.38.33.33,0,0,0,.38.27h0a2.69,2.69,0,0,1,2.24.9A.34.34,0,0,0,303.81,83.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M316.59,96.73c-1,5.15-1.62,12.28,2,15.71,0,0-1.4,5.22-11,5.22-10.51,0-5.05-4.58-5.05-4.58,4.37-1.36,4.33-6.34,3.33-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320.54,115.88c.94-1.33.9-5.51-.1-6.25-1.61-1.2-8.52-1.47-17.81.67,1,4.06-1.15,6.18-1.15,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M351.8,353.28a2.25,2.25,0,0,1-1.76-.09.7.7,0,0,1-.16-.78.8.8,0,0,1,.43-.49c.95-.45,3.13.44,3.23.48a.15.15,0,0,1,.1.15.19.19,0,0,1-.09.15A9.08,9.08,0,0,1,351.8,353.28Zm-1.15-1.12-.19.06a.46.46,0,0,0-.26.29c-.09.3,0,.39.06.42.38.33,1.78,0,2.77-.37A5.63,5.63,0,0,0,350.65,352.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M353.51,352.72h-.08c-.8-.23-2.5-1.44-2.52-2.24a.56.56,0,0,1,.43-.54.93.93,0,0,1,.73.06c.94.48,1.54,2.43,1.56,2.51a.17.17,0,0,1,0,.17Zm-2-2.49-.08,0c-.2.07-.2.17-.2.22,0,.47,1.14,1.42,2,1.8-.21-.56-.67-1.67-1.28-2A.58.58,0,0,0,351.52,350.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M299.86,354.46c-.9,0-1.77-.12-2.06-.53a.62.62,0,0,1,0-.72.8.8,0,0,1,.53-.39c1.17-.32,3.63,1.08,3.73,1.14a.15.15,0,0,1,.08.17.17.17,0,0,1-.13.14A12.36,12.36,0,0,1,299.86,354.46Zm-1.11-1.36a1,1,0,0,0-.32,0,.51.51,0,0,0-.33.23c-.12.21-.07.31,0,.37.33.45,2.1.47,3.41.28A7.61,7.61,0,0,0,298.75,353.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M302,354.27h-.07c-.85-.39-2.53-1.91-2.4-2.7,0-.19.16-.42.62-.47a1.2,1.2,0,0,1,.92.29,4.75,4.75,0,0,1,1.1,2.71.21.21,0,0,1-.07.15A.19.19,0,0,1,302,354.27Zm-1.72-2.85h-.1c-.3,0-.32.15-.32.19-.08.48,1.06,1.67,1.93,2.19a3.87,3.87,0,0,0-.93-2.16A.88.88,0,0,0,300.27,351.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "309.72 354.1 302.69 354.1 301.99 337.81 309.02 337.81 309.72 354.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "361.35 350.85 354.48 352.34 347.57 337.16 354.45 335.68 361.35 350.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M353.81,351.65l7.73-1.68a.61.61,0,0,1,.68.35l2.68,5.81a1,1,0,0,1-.74,1.44c-2.7.54-4.05.67-7.44,1.4-2.09.45-6.81,1.6-9.7,2.23s-3.88-2.15-2.75-2.66c5.05-2.31,7.15-4.34,8.52-6.23A1.67,1.67,0,0,1,353.81,351.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M302.74,353.29h7.68a.62.62,0,0,1,.6.48l1.39,6.25a1,1,0,0,1-1,1.25c-2.77,0-6.77-.21-10.25-.21-4.08,0-7.59.23-12.37.23-2.89,0-3.69-2.92-2.48-3.19,5.5-1.2,10-1.33,14.75-4.26A3.27,3.27,0,0,1,302.74,353.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331.17,114c6.59,1.51,12,18.34,12,18.34L330,142.46a28.93,28.93,0,0,1-7-13C320.67,120.64,324.43,112.48,331.17,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M331.17,114c6.59,1.51,12,18.34,12,18.34L330,142.46a28.93,28.93,0,0,1-7-13C320.67,120.64,324.43,112.48,331.17,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.5,134.11c-1.64,1.78-3.28,3.36-5,5-.85.81-1.71,1.6-2.59,2.38l-1.33,1.16-.33.29c-.16.14-.36.31-.57.47a8.71,8.71,0,0,1-1.93,1.14,6.48,6.48,0,0,1-2.44.5,6,6,0,0,1-2.1-.37,5.91,5.91,0,0,1-2-1.27,6,6,0,0,1-1.56-2.59,6.81,6.81,0,0,1-.29-1.49,10.22,10.22,0,0,1,0-1.79c.05-.48.11-.89.19-1.28a24.89,24.89,0,0,1,1.16-4,36.65,36.65,0,0,1,1.55-3.61c.64-1.27,1.25-2.2,1.86-3.26a81.65,81.65,0,0,1,8.45-11.46,77.42,77.42,0,0,1,10.25-9.72l3.68,3.79c-2.58,3.46-5.12,7.17-7.47,10.82a114.88,114.88,0,0,0-6.4,11.25c-.43.94-1,2-1.27,2.76a26.83,26.83,0,0,0-.93,2.7,17.16,17.16,0,0,0-.57,2.52,3.76,3.76,0,0,0,0,.4c0,.07,0,.12,0-.1a2.82,2.82,0,0,0-.13-.65,4.29,4.29,0,0,0-1.15-1.86,4.84,4.84,0,0,0-3.33-1.35,4.08,4.08,0,0,0-1.61.31c-.49.21-.5.27-.5.24l.38-.35,1.21-1.1,2.39-2.24c1.58-1.49,3.17-3.08,4.67-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M325.52,126.41c3.58,3.54,4.75,10,5,15.6l-.58.45a28.93,28.93,0,0,1-7-13c-.13-.53-.25-1.05-.34-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M289.51,121.08c-1.44,7.6-2.34,23.21,1.83,54.11H329c.26-5.78-3.37-33.95,2.2-61.16a99,99,0,0,0-12.6-1.59,137.48,137.48,0,0,0-16,0c-1.76.16-3.5.42-5,.69A10,10,0,0,0,289.51,121.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M289.51,121.08c-1.44,7.6-2.34,23.21,1.83,54.11H329c.26-5.78-3.37-33.95,2.2-61.16a99,99,0,0,0-12.6-1.59,137.48,137.48,0,0,0-16,0c-1.76.16-3.5.42-5,.69A10,10,0,0,0,289.51,121.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M295.27,132.31l-6.8-1.62c-.21,4.11-.23,9.22.07,15.53C291.67,142.65,295.67,137.1,295.27,132.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "301.99 337.82 302.35 346.21 309.39 346.21 309.03 337.82 301.99 337.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "354.45 335.68 347.57 337.17 351.13 344.99 358.01 343.5 354.45 335.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M319.93,89.2c-1.8,6.75-2.52,10.78-6.68,13.59C307,107,299.2,102.16,299,95c-.22-6.44,2.77-16.38,10-17.74A9.52,9.52,0,0,1,319.93,89.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.15,89.46c-.34-.9-1.89-7.87-.43-9.68s18.11-.51,20.57,1.92c4.09,4,1.25,7.6-3.22,12.23-3.36,3.48-3.49,7.4-5.19,8-3,1-7.58.06-8.5-3.11S304.15,89.46,304.15,89.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M322.27,73.77c-5.88-2.51-16.91.27-22.87-1.17A9.18,9.18,0,0,0,307,82a78.13,78.13,0,0,0,15,1.38C328.55,83.08,327.27,75.9,322.27,73.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M323.19,81.91a11.16,11.16,0,0,0,6.23-1.2C330.52,83.37,324.47,84.1,323.19,81.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M307.35,89.74a7.88,7.88,0,0,1-2,4.66c-1.54,1.69-3.14.64-3.41-1.42-.24-1.85.26-5,2.14-5.89S307.48,87.65,307.35,89.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M304.69,175.19s8,53.75,12.37,73.89c4.79,22,30.53,95,30.53,95l12.59-2.72s-18-59.46-22-90.29c-3.1-23.68-9.19-75.89-9.19-75.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.57,339.89c-.05,0,2.35,4.55,2.35,4.55l14.16-3.06-1.19-4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M309.74,194.34c9.23,1.81,8.25,36.23,7.14,53.93-2.66-12.51-6.56-36.59-9.22-53.68A3.15,3.15,0,0,1,309.74,194.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M291.34,175.19s-1,52.59-.2,74c.8,22.31,8.59,95.36,8.59,95.36h11.92s.43-71.75,1-93.66c.58-23.89,3.46-75.74,3.46-75.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M297.44,339.84c-.06,0,.67,5,.67,5H312.6l.4-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M304.25,123.39c3.37,9.09-16.44,19.79-16.44,19.79l-8.58-11S285,120.77,292,115.63C300.65,109.29,301.68,116.47,304.25,123.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M304.25,123.39c3.37,9.09-16.44,19.79-16.44,19.79l-8.58-11S285,120.77,292,115.63C300.65,109.29,301.68,116.47,304.25,123.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Thinking"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 381.87,
    cy: 31.38,
    rx: 36.09,
    ry: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.85,43a10.1,10.1,0,0,1-9.93-8.4A10.22,10.22,0,0,1,366.63,23h0a10.06,10.06,0,0,1,10.82,4.52l23.17-4.79a3.63,3.63,0,0,1,4.24,2.5,3.49,3.49,0,0,1-2.67,4.31l-.6.12a.59.59,0,0,0-.42.31.63.63,0,0,0,0,.52l.41,1.06a1.57,1.57,0,0,1-.62,1.92,1.94,1.94,0,0,0-.89,1.42,1.57,1.57,0,0,1-1.21,1.39l-.47.09a1.54,1.54,0,0,1-1.66-.79,1.94,1.94,0,0,0-3.61.74,1.55,1.55,0,0,1-1.2,1.39l-.47.1a1.57,1.57,0,0,1-1.66-.8,1.93,1.93,0,0,0-1.39-.94A1.59,1.59,0,0,1,387,34.55l0-1.14a.59.59,0,0,0-.24-.46.57.57,0,0,0-.5-.12l-7.39,1.52a10.07,10.07,0,0,1-7.95,8.39A9.69,9.69,0,0,1,368.85,43Zm-2-19a9.21,9.21,0,0,0-7,10.42,9.1,9.1,0,0,0,18-.51l0-.36L386,31.85a1.59,1.59,0,0,1,1.33.31,1.62,1.62,0,0,1,.62,1.21l0,1.13a.6.6,0,0,0,.48.58,2.91,2.91,0,0,1,2.11,1.43.58.58,0,0,0,.59.32l.46-.1a.57.57,0,0,0,.42-.53,2.94,2.94,0,0,1,5.47-1.12.55.55,0,0,0,.58.31l.48-.09a.56.56,0,0,0,.41-.53,2.9,2.9,0,0,1,1.37-2.14.61.61,0,0,0,.21-.72l-.41-1.06a1.62,1.62,0,0,1,1.18-2.17l.61-.12a2.44,2.44,0,0,0,1.61-1.13,2.47,2.47,0,0,0,.3-1.95,2.63,2.63,0,0,0-3.08-1.77L377,28.64l-.18-.31A9.05,9.05,0,0,0,366.85,24Zm2,15.29a6.38,6.38,0,1,1,1.3-.13h0A6.37,6.37,0,0,1,368.86,39.26Zm0-11.81a6,6,0,0,0-1.11.11A5.41,5.41,0,0,0,370,38.15h0a5.41,5.41,0,0,0-1.07-10.7Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 352.5,
    cy: 60.31,
    rx: 11.86,
    ry: 7.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 333.63,
    cy: 67.86,
    rx: 4.87,
    ry: 3.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgot);
export default __webpack_public_path__ + "static/media/forgot.0c44cbadca9cae47852df077cbf57737.svg";
export { ForwardRef as ReactComponent };